import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { PagetoolbarComponent } from '../pagetoolbar/pagetoolbar.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ExcludedListComponent } from './excluded-list/excluded-list.component';
import { AddExcludedComponent, AddExcludedDialogData, AddExcludedDialogResult } from './add-excluded/add-excluded.component';
import { Observable } from 'rxjs';
import { Crossmatch } from '../../interfaces/crossmatch';
import { MatDialog } from '@angular/material/dialog';
import { CrossmatchService } from '../../services/crossmatch.service';
import { PairService } from '../../services/pair.service';
import { NotifyService } from '../../common/notify/notify.service';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../auth/auth.service';
import { Permission } from '../../interfaces/permission';

type FilterType = 'current' | 'historical' | 'all';

@Component({
  selector: 'app-crossmatch',
  imports: [PagetoolbarComponent, MatCardModule, MatIconModule, MatToolbarModule, MatTabsModule, MatButtonToggleModule, ExcludedListComponent, CommonModule],
  providers: [NotifyService],
  templateUrl: './combination.component.html',
  styleUrl: './combination.component.scss'
})
export class CombinationComponent {
  @ViewChild(MatTabGroup, { static: true }) tabgroup!: MatTabGroup;

  public excludedCombinations?: Crossmatch[] = [];
  public filteredExcludedCombinations?: Crossmatch[] = [];

  public ecCount: number = 0;
  public pcCount: number = 0;
  public ncCount: number = 0;

  public selectedFilter: FilterType = 'current';

  private activeTab: number = 0;
  private searchFieldValue$!: Observable<string>;
  addCrossmatches: boolean = false;
  constructor(
    private readonly dialog: MatDialog,
    private readonly crossmatchService: CrossmatchService,
    private readonly pairService: PairService,
    private readonly authService: AuthService,
    private readonly notify: NotifyService
  ) {}

  ngOnInit(): void {
    this.authService.getAllPermissions$().subscribe((permissions) => {
      this.addCrossmatches = permissions.includes(Permission.CROSSMATCH_RESULT_ADD);
    });
    this.loadCrossmatches();
  }
  private loadCrossmatches(): void {
    this.crossmatchService.getAllCrossmatches().subscribe({
      next: (data: Crossmatch[]) => {
        this.excludedCombinations = data.filter((c) => c.excluded === true);
        this.applyFilter();
        this.crossmatchService.setExcludedCombinations(this.excludedCombinations);
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  public onFilterChange(filter: FilterType): void {
    this.selectedFilter = filter;
    this.applyFilter();
  }

  private applyFilter(): void {
    this.filteredExcludedCombinations = this.filterCrossmatches(this.excludedCombinations || []);
  }

  private filterCrossmatches(crossmatches: Crossmatch[]): Crossmatch[] {
    if (this.selectedFilter === 'all') {
      return crossmatches;
    }

    return crossmatches.filter((crossmatch) => {
      const donorHistorical = crossmatch.donor?.historical === true;
      const recipientHistorical = crossmatch.recipient?.historical === true;
      const donorMissing = !crossmatch.donor;
      const recipientMissing = !crossmatch.recipient;

      const isHistorical = donorHistorical || recipientHistorical || donorMissing || recipientMissing;

      if (this.selectedFilter === 'current') {
        return !isHistorical;
      } else if (this.selectedFilter === 'historical') {
        return isHistorical;
      }

      return true;
    });
  }
  openAddDialog() {
    const highlightRow = (data?: { donorId: string; recipientId: string }) => {
      if (!data) {
        return;
      }
      const newRow = document.getElementById(`${data.recipientId}|${data.donorId}`);
      if (newRow) {
        newRow.classList.add('highlight');
        this.openSnackBar('Added new excluded Recipient/Donor combination');
      }
    };

    if (this.tabgroup.selectedIndex === 0) {
      this.openExcludedDialog();
    }
  }

  private openExcludedDialog() {
    const dialogRef = this.dialog.open(AddExcludedComponent);
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) this.crossmatchService.addExcludedCombination(result);
    });
  }

  key(_index: number, crossmatch: Crossmatch) {
    return crossmatch.id;
  }

  openSnackBar(message: string, action?: string) {
    this.notify.withAutodismiss(message, action);
  }
}
